import { SvgIcon, SvgIconProps } from '@mui/material';

export const Beam = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 593 234"
      sx={{
        width: '593px',
        height: '234px',
        fill: 'none',
        ...sx,
      }}
      {...props}
    >
      <path
        opacity="0.3"
        d="M592.398 2H270.25C243.716 2 217.559 8.28506 193.922 20.3405L4.39844 117M4.39844 117H592.398M4.39844 117L193.922 213.66C217.559 225.715 243.716 232 270.25 232H592.398"
        stroke="url(#paint0_linear_12508_19124)"
        strokeWidth="4"
      />
      <defs>
        <linearGradient
          id="paint0_linear_12508_19124"
          x1="3.94015"
          y1="117"
          x2="592.398"
          y2="117"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0B90B" />
          <stop offset="1" stopColor="#999999" stopOpacity="0" />
        </linearGradient>
      </defs>
    </SvgIcon>
  );
};
